export default {
  beforeDestroy() {
    if(this.$options.timerList) {
      this.$options.timerList.forEach(timerInfo => {
        clearTimeout(timerInfo.timerId)
      })

      this.$options.timerList = []
    }
  },
  methods: {
    createTimeoutTimer(name, callback, interval) {
      if(!this.$options.timerList)
        this.$options.timerList = []

      let timerId = setTimeout(callback, interval)

      this.$options.timerList.push({
        name: name,
        timerId: timerId
      })
    },
    createIntervalTimer(name, callback, interval) {
      if(!this.$options.timerList)
        this.$options.timerList = []

      let timerId = setInterval(callback, interval)

      this.$options.timerList.push({
        name: name,
        timerId: timerId
      })
    },
    clearTimer(name) {
      if(!this.$options.timerList)
        this.$options.timerList = []

      var timerInfoList = this.$options.timerList.filter(timerInfo => timerInfo.name == name)
      timerInfoList.forEach(timerInfo => {
        clearTimeout(timerInfo.timerId)
      })

      this.$options.timerList = this.$options.timerList.filter(timerInfo => timerInfo.name != name)
    }
  }
}
